import { Div, Icon, Touchable } from "@grassrootly/rn-core";
import GamePlayer from "./GamePlayer";
import { GamePlayersProps } from "./GameAttendees.types";
import { useCallback } from "react";

export default function GamePlayers({ attendees, showTeam, onSelected, selectedId, showPoints }: GamePlayersProps) {
  return (
    <Div classNames={["flex1"]}>
      {attendees
        .filter((a) => a.attended)
        .map((attendee, index) => {
          const onRowPress = useCallback(() => {
            if (onSelected) {
              onSelected(attendee.id);
            }
          }, [attendee]);
          return (
            <Touchable
              onPress={onRowPress}
              disabled={!onSelected}
              key={index}
              classNames={["p16", index % 2 !== 0 ? "bgSecondaryMain" : "", "flexRow", "alignItemsCenter"]}
            >
              {onSelected ? (
                <Div
                  classNames={[
                    "h-{15}",
                    "w-{15}",
                    "br-{15}",
                    "borderPrimary",
                    "bw-{1}",
                    "mr-{16}",
                    "alignItemsCenter",
                    "justifyContentCenter",
                    selectedId === attendee.id ? "bgPrimaryMain" : "",
                  ]}
                >
                  {selectedId === attendee.id ? (
                    <Icon classNames={["colorNeutralLighterLight"]} size={12} name="check" />
                  ) : null}
                </Div>
              ) : null}
              <GamePlayer attendee={attendee} showTeam={showTeam} showPoints={showPoints} />
            </Touchable>
          );
        })}
    </Div>
  );
}
